<template>
    <div class="col-xs-12 col-sm-6 col-md-3">
        <q-card class="q-pa-md text-center hover-card">
            <q-icon style="color:#003447" :name="icon" size="40px" />
            <div style="color:#005675" class="text-h6">{{ title }}</div>
            <div style="color:#005675" class="text-subtitle1"> <q-chip color="primary" text-color="white">
                    {{ value }}
                </q-chip></div>
        </q-card>
    </div>
</template>

<script>
export default {
    name: "MetricCard",
    props: {
        title: String,
        value: [String, Number],
        icon: String,
        color: String
    }
};
</script>
<style>
.color-1 {
    background-color: #E6F8FF;
}

.color-2 {
    background-color: #B8ECFF;
}

.color-3 {
    background-color: #8AE0FF;
}

.color-4 {
    background-color: #5CD3FF;
}

.color-5 {
    background-color: #2EC7FF;
}

.hover-card:hover {
    background-color: #E6F8FF;
    cursor: pointer;
}
</style>